import * as React from 'react'

import { styled } from '@thg-commerce/gravity-theme'
import { Button } from '@thg-commerce/gravity-elements'

export interface ProductButtonProps {
  title: string
  href?: string
  disabled?: boolean
  ariaLabel?: string
  onClick?: (event: React.MouseEvent<Element, MouseEvent>) => void
  dataTestId?: string
  className?: string
}

const StyledButton = styled(Button)`
  max-width: 100%;
  cursor: pointer;
`

const ButtonContent = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
`

export const ProductButton = ({
  title,
  href,
  disabled,
  ariaLabel,
  onClick,
  dataTestId,
  className,
}: ProductButtonProps) => {
  return (
    <StyledButton
      emphasis="high"
      sizing="regular"
      href={href}
      // Render as div for onClick function to not be overridden by a tag
      renderedAs={disabled ? undefined : href ? 'a' : 'div'}
      disabled={disabled}
      ariaLabel={ariaLabel}
      onClick={onClick}
      data-testid={dataTestId}
      className={className}
    >
      <ButtonContent>{title}</ButtonContent>
    </StyledButton>
  )
}
